export enum ROLES {
    APPLICATION_ADMINISTRATOR = 'Application Administrator',
}
